import { createContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import useAltEffect from "shared/hooks/useAltEffect";
import useLocalStorage from "shared/hooks/useLocalStorage";
import {
  decode,
  encode,
  getRoleFromTokenPayload,
  getTokenPayload,
  removeLocalStorage,
} from "shared/utils/Utils";
import { storeRequester } from "App";
import { RegionReducer } from "shared/redux/reducers/region/RegionReducer";

export const RegionContext = createContext({
  regionName: String,
  regionId: String,
  currencyCode: String,
  authCheckDone: Boolean,
});

function RegionProvider(props) {
  const [regionId, setRegionId] = useState("");
  const [regionName, setRegionName] = useState("");
  const [currencyCode, setCurrencyCode] = useState("");
  const [tokenInStorage] = useLocalStorage("region");
  const [i18nextLng] = useLocalStorage("i18nextLng");
  const dispatch = useDispatch();
  const { token } = useSelector((state) => ({
    token: state.region.token,
  }));

  useEffect(() => {
    dispatch(RegionReducer.actions.setToken(tokenInStorage));
  }, []);

  useAltEffect(() => {
    if (token) {
      try {
        
        const tokenPayload = getTokenPayload(token);
        if (tokenPayload) {
          
          setRegionId(tokenPayload.id);
          setRegionName(tokenPayload.name);
          setCurrencyCode(tokenPayload.currencyCode);
        }
      } catch (e) {}
    } else {
      let currency_code;
      switch (i18nextLng) {
        case "ko-KR":
        default: {
          currency_code = "krw";
          break;
        }
      }
      storeRequester.getRegions(({ regions }) => {
        if (regions?.length > 0) {
          const region = regions.find((f) => f.currency_code === currency_code);
          const data = {
            id: region.id,
            name: region.name,
            currency_code: region.currency_code,
          };

          dispatch(
            RegionReducer.actions.setToken(encode(JSON.stringify(data)))
          );
        }
      });
      setRegionName(null);
      setCurrencyCode(null);
    }
  }, [token]);
  

  return (
    <RegionContext.Provider
      value={{
        regionName,
        regionId,
        currencyCode,
      }}
    >
      {props.children}
    </RegionContext.Provider>
  );
}

export default RegionProvider;
